import { createApp } from "vue";
import router from "./router";
import store from "./stores";
import i18n from "./i18n";
import "./assets/main.css";
import Toast from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";
import App from "./App.vue";
import DashboardLayout from "./components/DashboardLayout.vue";
import EmptyLayout from "./components/EmptyLayout.vue";
// component global
import BComponent from "./components";
import LitepieDatepicker from "litepie-datepicker";
import PrimeVue from "primevue/config";
import Aura from "@primevue/themes/aura";

// create the app
const app = createApp(App);
app.use(store);
app.use(i18n);
// register global component
app.component("default-layout", DashboardLayout);
app.component("empty-layout", EmptyLayout);
app.use(PrimeVue, {});

// register router and store
app.use(PrimeVue);
app.use(router);
app.use(BComponent);
app.use(LitepieDatepicker);
app.use(Toast);

// mount the app
app.mount("#app");
